import { SubscriptionPlanModuleId } from "@jugl-web/rest-api";
import { PageNavParams } from "@web-src/modules/navigation/types";
import { ModulePagesConfig } from "@web-src/modules/navigation/types/ModulePagesConfigs";
import { lazy } from "react";

const AutomationPage = lazy(() => import("./AutomationPage"));

export type AutomationPagesNavigationParams = {
  integrations: PageNavParams;
};

export const automationPagesNavigationConfig: ModulePagesConfig<AutomationPagesNavigationParams> =
  {
    integrations: {
      element: <AutomationPage />,
      path: "automation",
      isPrivate: true,
      requiredModules: [SubscriptionPlanModuleId.automation],
    },
  };
